module.exports = function() {
  return new Worker("/" + "babel-transpiler.cde5cdb0.worker.js");
};